import React, { Component, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Header from "../component/layout/header";
import PageHeader from "../component/layout/pageheader";
import FooterSection from "../component/layout/footer";
import FilterSearchSection from "../component/section/filtersearch";
import WidgetLikeSection from "../component/section/widgetlike";
import WidgetGroupSection from "../component/section/widgetgroup";
import AllPhotos from "../component/section/photos";
import GroupItemTwo from "../component/items/groupitemtwo";
import CommentModal from "../component/models/CommentModal";
import axios from "axios";
import { GridLoader, SyncLoader } from "react-spinners";
import { toast, ToastContainer } from "react-toastify";
import { convertImageToWebP } from "../utils/convertToWebp";

const PostPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasAutoSubmitted = useRef(false);

  const [postText, setPostText] = useState("");
  const [images, setImages] = useState([]);
  const fileInputRef = useRef(null);

  const [groupList, setGroupList] = useState([]);
  const [loadingGroups, setLoadingGroups] = useState(false);

  const [loading, setLoading] = useState(true);

  // show posts

  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(1);
  const pageRef = useRef(1);
  const [postType, setPostType] = useState("all");
  const [hasMore, setHasMore] = useState(true);

  const [userHasPlan, setUserHasPlan] = useState(false);
  const [isPosting, setIsPosting] = useState(false);
  const [isUploadingImage, setIsUploadingImage] = useState(false);

  const [postToDelete, setPostToDelete] = useState(null);

  const [showCommentModal, setShowCommentModal] = useState(false);
  const [activeCommentPostId, setActiveCommentPostId] = useState(null);

  const openCommentModal = (e, postId) => {
    e.preventDefault();
    setActiveCommentPostId(postId);
    setShowCommentModal(true);
  };

  // const handleImageUpload = async (e) => {
  //   const files = Array.from(e.target.files).slice(0, 2);

  //   setIsUploadingImage(true);
  //   for (let file of files) {
  //     const formData = new FormData();
  //     formData.append("image", file);

  //     try {
  //       const res = await axios.post(
  //         `${process.env.REACT_APP_MAIN_SITE_URL}/upload-image`,
  //         formData,
  //         {
  //           headers: {
  //             "Content-Type": "multipart/form-data",
  //           },
  //         }
  //       );

  //       const imageUrl = res.data.data.url;
  //       setImages((prev) => [...prev, { url: imageUrl }].slice(0, 2));
  //     } catch (err) {

  //       toast.error("Image upload failed!");
  //     }

  //     setIsUploadingImage(false);
  //   }
  // };

  const handleImageUpload = async (e) => {
    const files = Array.from(e.target.files).slice(0, 2);
    setIsUploadingImage(true);

    for (let file of files) {
      try {
        const webpBlob = await convertImageToWebP(file);
        const webpFile = new File([webpBlob], "image.webp", {
          type: "image/webp",
        });

        const formData = new FormData();
        formData.append("image", webpFile);

        const res = await axios.post(
          `${process.env.REACT_APP_MAIN_SITE_URL}/upload-image`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        const imageUrl = res.data.data.url;
        setImages((prev) => [...prev, { url: imageUrl }].slice(0, 2));
      } catch (err) {
        console.error("WebP conversion or upload failed", err);
        toast.error("Image upload failed!");
      }
    }

    setIsUploadingImage(false);
  };

  const removeImage = (index) => {
    const newImages = [...images];
    newImages.splice(index, 1);
    setImages(newImages);
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  const token = localStorage.getItem("token");

  const handleSubmit = async () => {
    if (!postText.trim() && images.length === 0) {
      toast.error("Post text or image is required.");
      return;
    }

    // for check is user buy a plan
    const planCheckRes = await axios.get(
      `${process.env.REACT_APP_MAIN_SITE_URL}/user/has-plan`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!planCheckRes.data.has_plan) {
      // Save pending post data in sessionStorage
      sessionStorage.setItem(
        "pendingPost",
        JSON.stringify({
          body: postText,
          images: images.map((img) => img.url),
          postType: postType,
        })
      );

      // Redirect to pricing with "from" current path
      navigate("/pricing", { state: { from: location.pathname } });
      return;
    }
    // check

    const payload = {
      body: postText,
      image_urls: images.map((img) => img.url),
    };

    try {
      const token = localStorage.getItem("token");

      setIsUploadingImage(true);

      await axios.post(
        `${process.env.REACT_APP_MAIN_SITE_URL}/post/store`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Post submitted!");
      setPostText("");
      setImages([]);

      getPosts(true, postType);
    } catch (err) {
      toast.error("Post failed to submit!");
    }

    setIsUploadingImage(false);
  };

  const handleTabChange = (type) => {
    setPostType(type);
    setPage(1);
    pageRef.current = 1;
    getPosts(true, type);
  };

  const [loadingMore, setLoadingMore] = useState(false);
  const observer = useRef();
  const getPostsRef = useRef();
  const hasMoreRef = useRef(hasMore);
  const loadingMoreRef = useRef(loadingMore);

  useEffect(() => {
    getPostsRef.current = getPosts;
  });

  useEffect(() => {
    hasMoreRef.current = hasMore;
  }, [hasMore]);

  useEffect(() => {
    loadingMoreRef.current = loadingMore;
  }, [loadingMore]);
  
  const lastElementRef = React.useCallback((node) => {
    if (loadingMore || !node) return;
    if (!observer.current) {
      observer.current = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && hasMoreRef.current && !loadingMoreRef.current) {
            if (getPostsRef.current) getPostsRef.current();
          }
        });
      });
    }
    observer.current.observe(node);
  }, [loadingMore]);

  const getPosts = async (reset = false, type = postType) => {
    if (!reset && loadingMoreRef.current) return;
    if (!reset) {
      setLoadingMore(true);
      loadingMoreRef.current = true;
    }
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_MAIN_SITE_URL}/post?page=${
          reset ? 1 : pageRef.current
        }&type=${type}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      const newPosts = res.data.data.posts.data;

      setPosts((prev) => {
        if (reset) return newPosts;
        const unique = [...prev, ...newPosts].filter(
          (v, i, a) => a.findIndex((t) => t.id === v.id) === i
        );
        return unique;
      });

      // setHasMore(res.data.data.posts.next_page_url !== null);

      // if (!userHasPlan) {
      //   setHasMore(false);
      // } else {
      //   setHasMore(res.data.data.posts.next_page_url !== null);
      // }

      setUserHasPlan(res.data.data.has_plan); // update this first

      if (!res.data.data.has_plan) {
        setHasMore(false);
      } else {
        setHasMore(res.data.data.posts.next_page_url !== null);
      }

      const nextPage = reset ? 2 : pageRef.current + 1;
      setPage(nextPage);
      pageRef.current = nextPage;
      
      setUserHasPlan(res.data.data.has_plan);
    } catch (err) {
      console.error("Fetch failed", err);
    } finally {
      if (!reset) {
        setLoadingMore(false);
        loadingMoreRef.current = false;
      }
    }
  };

  useEffect(() => {
    getPosts(true, postType);
    getLatestGroups();
  }, [postType]);

  useEffect(() => {
    if (hasAutoSubmitted.current) return;
    const pendingPost = sessionStorage.getItem("pendingPost");
    if (pendingPost) {
      hasAutoSubmitted.current = true;

      const {
        body,
        images: pendingImages,
        postType: savedPostType,
      } = JSON.parse(pendingPost);

      setPostText(body);
      setImages(pendingImages.map((url) => ({ url })));
      setPostType(savedPostType || "all");

      (async () => {
        try {
          const token = localStorage.getItem("token");
          if (!token) return;

          const planCheckRes = await axios.get(
            `${process.env.REACT_APP_MAIN_SITE_URL}/user/has-plan`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );

          if (planCheckRes.data.has_plan) {
            const payload = {
              body,
              image_urls: pendingImages,
            };

            await axios.post(
              `${process.env.REACT_APP_MAIN_SITE_URL}/post/store`,
              payload,
              {
                headers: { Authorization: `Bearer ${token}` },
              }
            );

            toast.success("Successfuly Created Post");

            setPostText("");
            setImages([]);
            getPosts(true, savedPostType || "all");

            // Clear pending post so it won't submit again
            sessionStorage.removeItem("pendingPost");

            setUserHasPlan(true);
          }
        } catch (error) {
          console.error("Failed to auto submit pending post", error);
        }
      })();
    }
  }, []);

  const handleProfileClick = (targetUserId) => {
    const loggedInUserId = localStorage.getItem("user_id");

    if (userHasPlan || String(targetUserId) === loggedInUserId) {
      navigate("/profile", { state: { userId: targetUserId } });
    } else {
      navigate("/pricing", {
        state: { from: { pathname: "/profile", userId: targetUserId } },
      });
    }
  };

  const getLatestGroups = async () => {
    axios
      .get(`${process.env.REACT_APP_MAIN_SITE_URL}/latest-groups`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setGroupList(res.data.data);

        console.log(res.data.data);
      })
      .catch((error) => {
        console.error("Failed to fetch top groups:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDeletePost = async (postId) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${process.env.REACT_APP_MAIN_SITE_URL}/post/delete/${postId}`,
        {}, // empty body
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        toast.success("Post deleted successfully!");
        setPosts(posts.filter((post) => post.id !== postId));
      } else {
        toast.error(response.data.message || "Failed to delete post");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to delete post");
      console.error("Delete failed", err);
    }
  };

  const confirmDelete = () => {
    handleDeletePost(postToDelete);
    setPostToDelete(null);
  };

  const cancelDelete = () => {
    setPostToDelete(null);
  };

  return (
    <div>
      <Header />
      <PageHeader title={"Post List"} />
      <section className="profile-section padding-tb">
        <div className="container">
          <div className="section-wrapper">
            <div className="member-profile">
              <div className="profile-details">
                <div className="tab-content" id="nav-tabContent">
                  <div
                    className="tab-pane activity-page fade show active"
                    id="activity"
                    role="tabpanel"
                  >
                    <div>
                      <div className="row">
                        <div className="col-xl-8">
                          <article>
                            <div className="activity-tab">
                              <ul
                                className="nav nav-pills mb-3"
                                id="pills-tab"
                                role="tablist"
                              >
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link"
                                    id="pills-personal-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-personal"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-personal"
                                    aria-selected="false"
                                    onClick={() => handleTabChange("my")}
                                  >
                                    <i className="icofont-user"></i>
                                    My Posts
                                  </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link active"
                                    id="pills-mentions-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-mentions"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-mentions"
                                    aria-selected="true"
                                    onClick={() => handleTabChange("all")}
                                  >
                                    <i className="icofont-edit"></i>
                                    All Posts
                                  </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link"
                                    id="pills-favorites-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-favorites"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-favorites"
                                    aria-selected="false"
                                    onClick={() => handleTabChange("friends")}
                                  >
                                    <i className="icofont-heart-alt"></i>
                                    Friends Posts
                                  </button>
                                </li>

                                <li className="custom-select">
                                  <select>
                                    <option value="1">Everything</option>
                                    <option value="2">Recent</option>
                                    <option value="3">Relevant</option>
                                    <option value="4">Popular</option>
                                  </select>
                                </li>
                              </ul>

                              <div
                                className="tab-content activity-content"
                                id="pills-tabContent"
                              >
                                <div
                                  className="tab-pane fade"
                                  id="pills-personal"
                                  role="tabpanel"
                                  aria-labelledby="pills-personal-tab"
                                >
                                  {posts.map((post) => (
                                    <div
                                      className="post-item mb-20"
                                      key={post.id}
                                    >
                                      <div className="post-content">
                                        <div className="post-author">
                                          <div className="post-author-inner">
                                            <div className="author-thumb">
                                              <img
                                                src={
                                                  post.user?.profile_image ||
                                                  "assets/images/profile/dp.png"
                                                }
                                                className="rounded-circle revert-layer-img-height"
                                                width="40"
                                                height="40"
                                                alt="img"
                                              />
                                            </div>
                                            <div className="author-details">
                                              <h6>
                                                <a href="#">
                                                  {post.user?.name}
                                                </a>
                                              </h6>
                                              <ul className="post-status">
                                                <li className="post-privacy">
                                                  <i className="icofont-world"></i>{" "}
                                                  Public
                                                </li>
                                                <li className="post-time">
                                                  {post.time_ago}
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="post-description">
                                          <p>{post.body}</p>
                                          {post.image_urls?.length > 0 && (
                                            <div className="post-desc-img">
                                              <div className="row g-3">
                                                {post.image_urls.map(
                                                  (img, idx) => (
                                                    <div
                                                      className={
                                                        post.image_urls
                                                          .length === 2
                                                          ? "col-md-6"
                                                          : "col-md-12"
                                                      }
                                                      key={idx}
                                                    >
                                                      <img
                                                        src={img}
                                                        alt="post"
                                                        className="w-100"
                                                      />
                                                    </div>
                                                  )
                                                )}
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="post-meta">
                                        <div className="post-meta-top">
                                          <p>
                                            <a href="#">
                                              <i className="icofont-like"></i>{" "}
                                              <i className="icofont-heart"></i>{" "}
                                              <span>Liked by others</span>
                                            </a>
                                          </p>
                                          <p>
                                            <a href="#">Comments</a>
                                          </p>
                                        </div>
                                        <div className="post-meta-bottom">
                                          <ul className="react-list">
                                            <li className="react">
                                              <a href="#">
                                                <i className="icofont-like"></i>{" "}
                                                Like
                                              </a>
                                            </li>
                                            <li className="react">
                                              <a href="#" onClick={(e) => openCommentModal(e, post.id)}>
                                                <i className="icofont-speech-comments"></i>{" "}
                                                Comment
                                              </a>
                                            </li>
                                            {/* <li className="react">
                                              <a href="#">
                                                <i className="icofont-share"></i>{" "}
                                                Share
                                              </a>
                                            </li> */}

                                            {post.can_edit && (
                                              <li className="react">
                                                <a
                                                  href="#"
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    setPostToDelete(post.id);
                                                  }}
                                                  className="text-danger"
                                                >
                                                  <i className="icofont-ui-delete"></i>{" "}
                                                  Delete
                                                </a>
                                              </li>
                                            )}
                                          </ul>
                                        </div>
                                      </div>

                                    </div>
                                  ))}

                                  {hasMore && (
                                    <div className="load-btn text-center my-4 py-3">
                                      <a href="#" className="dating-load-more-btn" onClick={(e) => { e.preventDefault(); getPosts(); }}>Click here for more {loadingMore && <i className="icofont-spinner dating-spinner"></i>}</a>
                                    </div>
                                  )}
                                </div>

                                <div
                                  className="tab-pane fade mentions-section show active"
                                  id="pills-mentions"
                                  role="tabpanel"
                                  aria-labelledby="pills-mentions-tab"
                                >
                                  <div className="create-post mb-20">
                                    <div className="lab-inner">
                                      <div className="lab-thumb">
                                        <div className="thumb-inner">
                                          {/* <div className="thumb-img">
                                            <img
                                              src="assets/images/profile/dp.png"
                                              alt="img"
                                            />
                                          </div> */}

                                           <div
                                            style={{
                                              width: "12vw",
                                              height: "12vw",
                                              maxWidth: "50px",
                                              maxHeight: "50px",
                                              minWidth: "35px",
                                              minHeight: "35px",
                                              borderRadius: "50%",
                                              overflow: "hidden",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                            }}
                                            className="me-2"
                                          >
                                            <img
                                              src="assets/images/profile/dp2.png"
                                              alt="profile"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                                borderRadius: "50%",
                                              }}
                                            />
                                          </div>

                                          
                                          <div className="thumb-content">
                                            <h6>
                                              {/* <a href="#">Your Name</a> */}
                                            </h6>
                                            <div className="custom-select">
                                              <select>
                                                <option value="1">
                                                  &#xf02c; Public
                                                </option>
                                                <option value="2">
                                                  &#xec61; Private
                                                </option>
                                                <option value="3">
                                                  &#xed0d; Friends
                                                </option>
                                              </select>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      {isUploadingImage && (
                                        // <div className="d-flex justify-content-center my-2">
                                        //   <SyncLoader
                                        //     size={10}
                                        //     color="#DF314D"
                                        //   />
                                        // </div>
                                        <div className="fullscreen-loader">
                                          <SyncLoader
                                            size={12}
                                            color="#DF314D"
                                          />
                                        </div>
                                      )}

                                      <div className="lab-content">
                                        <form className="post-form">
                                          <input
                                            type="text"
                                            placeholder="Whats on your mind.?"
                                            value={postText}
                                            onChange={(e) =>
                                              setPostText(e.target.value)
                                            }
                                          />

                                          {images.length > 0 && (
                                            <div className="post-description">
                                              <div className="post-desc-img">
                                                <div className="row g-3">
                                                  {images.map(
                                                    (image, index) => (
                                                      <div
                                                        className="col-md-6"
                                                        key={index}
                                                      >
                                                        <div
                                                          className="image-wrapper"
                                                          style={{
                                                            position:
                                                              "relative",
                                                          }}
                                                        >
                                                          <img
                                                            src={image.url}
                                                            alt="upload preview"
                                                            className="w-100"
                                                          />
                                                          <button
                                                            type="button"
                                                            className="remove-image-btn"
                                                            onClick={() =>
                                                              removeImage(index)
                                                            }
                                                            title="Remove"
                                                          >
                                                            ×
                                                          </button>
                                                        </div>
                                                      </div>
                                                    )
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          )}

                                          <div className="content-type">
                                            <ul className="content-list">
                                              <li className="text">
                                                <i className="icofont-edit"></i>{" "}
                                                Text
                                              </li>
                                              <li className="image-video">
                                                <div
                                                  className="file-btn"
                                                  onClick={triggerFileInput}
                                                  style={{ cursor: "pointer" }}
                                                >
                                                  <i className="icofont-camera"></i>{" "}
                                                  Photo
                                                </div>
                                                <input
                                                  ref={fileInputRef}
                                                  type="file"
                                                  style={{ display: "none" }}
                                                  accept="image/*"
                                                  onChange={handleImageUpload}
                                                  multiple
                                                />
                                              </li>
                                              <li className="attach-file">
                                                <div className="file-btn">
                                                  <i className="icofont-paper-clip"></i>
                                                  Attach File
                                                </div>
                                                {/* <input type="file" /> */}
                                              </li>
                                              <li className="post-submit">
                                                <input
                                                  type="button"
                                                  value="Post"
                                                  className="lab-btn"
                                                  onClick={handleSubmit}
                                                />
                                              </li>
                                            </ul>
                                          </div>
                                        </form>
                                      </div>
                                    </div>
                                  </div>

                                  {posts.map((post) => (
                                    <div
                                      className="post-item mb-20"
                                      key={post.id}
                                    >
                                      <div className="post-content">
                                        <div className="post-author">
                                          <div className="post-author-inner">
                                            <div className="author-thumb">
                                              <img
                                                src={
                                                  post.user?.profile_image ||
                                                  "assets/images/profile/dp.png"
                                                }
                                                className="rounded-circle revert-layer-img-height"
                                                width="40"
                                                height="40"
                                                alt="img"
                                                onClick={() =>
                                                  handleProfileClick(
                                                    post.user?.id
                                                  )
                                                }
                                              />
                                            </div>
                                            <div className="author-details">
                                              <h6>
                                                <span
                                                  style={{
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() =>
                                                    handleProfileClick(
                                                      post.user?.id
                                                    )
                                                  }
                                                >
                                                  {post.user?.name}
                                                </span>
                                              </h6>

                                              <ul className="post-status">
                                                <li className="post-privacy">
                                                  <i className="icofont-world"></i>{" "}
                                                  Public
                                                </li>
                                                <li className="post-time">
                                                  {post.time_ago}
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="post-description">
                                          <p>{post.body}</p>
                                          {post.image_urls?.length > 0 && (
                                            <div className="post-desc-img">
                                              <div className="row g-3">
                                                {post.image_urls.map(
                                                  (img, idx) => (
                                                    <div
                                                      className={
                                                        post.image_urls
                                                          .length === 2
                                                          ? "col-md-6"
                                                          : "col-md-12"
                                                      }
                                                      key={idx}
                                                    >
                                                      <img
                                                        src={img}
                                                        alt="post"
                                                        className="w-100"
                                                      />
                                                    </div>
                                                  )
                                                )}
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="post-meta">
                                        <div className="post-meta-top">
                                          <p>
                                            <a href="#">
                                              <i className="icofont-like"></i>{" "}
                                              <i className="icofont-heart"></i>{" "}
                                              <span>Liked by others</span>
                                            </a>
                                          </p>
                                          <p>
                                            <a href="#">Comments</a>
                                          </p>
                                        </div>
                                        <div className="post-meta-bottom">
                                          <ul className="react-list">
                                            <li className="react">
                                              <a href="#">
                                                <i className="icofont-like"></i>{" "}
                                                Like
                                              </a>
                                            </li>
                                            <li className="react">
                                              <a href="#" onClick={(e) => openCommentModal(e, post.id)}>
                                                <i className="icofont-speech-comments"></i>{" "}
                                                Comment
                                              </a>
                                            </li>
                                            {/* <li className="react">
                                              <a href="#">
                                                <i className="icofont-share"></i>{" "}
                                                Share
                                              </a>
                                            </li> */}

                                            {post.can_edit && (
                                              <li className="react">
                                                <a
                                                  href="#"
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    setPostToDelete(post.id);
                                                  }}
                                                  className="text-danger"
                                                >
                                                  <i className="icofont-ui-delete"></i>{" "}
                                                  Delete
                                                </a>
                                              </li>
                                            )}
                                          </ul>
                                        </div>
                                      </div>

                                    </div>
                                  ))}

                                  {hasMore && (
                                    <div className="load-btn text-center my-4 py-3">
                                      <a href="#" className="dating-load-more-btn" onClick={(e) => { e.preventDefault(); getPosts(); }}>Click here for more {loadingMore && <i className="icofont-spinner dating-spinner"></i>}</a>
                                    </div>
                                  )}
                                </div>

                                {postToDelete && (
                                  <div
                                    className="modal fade show"
                                    style={{
                                      display: "block",
                                      backgroundColor: "rgba(0,0,0,0.5)",
                                    }}
                                  >
                                    <div className="modal-dialog modal-dialog-centered">
                                      <div className="modal-content">
                                        <div className="modal-header">
                                          <h5 className="modal-title">
                                            Delete Post
                                          </h5>
                                        </div>
                                        <div className="modal-body">
                                          Are you sure you want to delete this
                                          post?
                                        </div>
                                        <div className="modal-footer">
                                          <button
                                            type="button"
                                            className="btn btn-secondary"
                                            onClick={cancelDelete}
                                          >
                                            Cancel
                                          </button>
                                          <button
                                            type="button"
                                            className="btn btn-danger"
                                            onClick={confirmDelete}
                                          >
                                            Delete
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}

                                <div
                                  className="tab-pane fade"
                                  id="pills-favorites"
                                  role="tabpanel"
                                  aria-labelledby="pills-favorites-tab"
                                >
                                  {posts.map((post) => (
                                    <div
                                      className="post-item mb-20"
                                      key={post.id}
                                    >
                                      <div className="post-content">
                                        <div className="post-author">
                                          <div className="post-author-inner">
                                            <div className="author-thumb">
                                              <img
                                                src={
                                                  post.user?.profile_image ||
                                                  "assets/images/profile/dp.png"
                                                }
                                                className="rounded-circle revert-layer-img-height"
                                                width="40"
                                                height="40"
                                                alt="img"
                                              />
                                            </div>
                                            <div className="author-details">
                                              <h6>
                                                <span
                                                  style={{ cursor: "pointer" }}
                                                  onClick={() =>
                                                    handleProfileClick(
                                                      post.user?.id
                                                    )
                                                  }
                                                >
                                                  {post.user?.name}
                                                </span>
                                              </h6>

                                              <ul className="post-status">
                                                <li className="post-privacy">
                                                  <i className="icofont-world"></i>{" "}
                                                  Public
                                                </li>
                                                <li className="post-time">
                                                  {post.time_ago}
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="post-description">
                                          <p>{post.body}</p>
                                          {post.image_urls?.length > 0 && (
                                            <div className="post-desc-img">
                                              <div className="row g-3">
                                                {post.image_urls.map(
                                                  (img, idx) => (
                                                    <div
                                                      className={
                                                        post.image_urls
                                                          .length === 2
                                                          ? "col-md-6"
                                                          : "col-md-12"
                                                      }
                                                      key={idx}
                                                    >
                                                      <img
                                                        src={img}
                                                        alt="post"
                                                        className="w-100"
                                                      />
                                                    </div>
                                                  )
                                                )}
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="post-meta">
                                        <div className="post-meta-top">
                                          <p>
                                            <a href="#">
                                              <i className="icofont-like"></i>{" "}
                                              <i className="icofont-heart"></i>{" "}
                                              <span>Liked by others</span>
                                            </a>
                                          </p>
                                          <p>
                                            <a href="#">Comments</a>
                                          </p>
                                        </div>
                                        <div className="post-meta-bottom">
                                          <ul className="react-list">
                                            <li className="react">
                                              <a href="#">
                                                <i className="icofont-like"></i>{" "}
                                                Like
                                              </a>
                                            </li>
                                            <li className="react">
                                              <a href="#" onClick={(e) => openCommentModal(e, post.id)}>
                                                <i className="icofont-speech-comments"></i>{" "}
                                                Comment
                                              </a>
                                            </li>
                                            {/* <li className="react">
                                              <a href="#">
                                                <i className="icofont-share"></i>{" "}
                                                Share
                                              </a>
                                            </li> */}

                                            {post.can_edit && (
                                              <li className="react">
                                                <a
                                                  href="#"
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    setPostToDelete(post.id);
                                                  }}
                                                  className="text-danger"
                                                >
                                                  <i className="icofont-ui-delete"></i>{" "}
                                                  Delete
                                                </a>
                                              </li>
                                            )}
                                          </ul>
                                        </div>
                                      </div>

                                    </div>
                                  ))}

                                  {hasMore && (
                                    <div className="load-btn text-center my-4 py-3">
                                      <a href="#" className="dating-load-more-btn" onClick={(e) => { e.preventDefault(); getPosts(); }}>Click here for more {loadingMore && <i className="icofont-spinner dating-spinner"></i>}</a>
                                    </div>
                                  )}
                                </div>
                                <div
                                  className="tab-pane fade"
                                  id="pills-friends"
                                  role="tabpanel"
                                  aria-labelledby="pills-friends-tab"
                                >
                                  {posts.map((post) => (
                                    <div
                                      className="post-item mb-20"
                                      key={post.id}
                                    >
                                      <div className="post-content">
                                        <div className="post-author">
                                          <div className="post-author-inner">
                                            <div className="author-thumb">
                                              <img
                                                src={
                                                  post.user?.profile_image ||
                                                  "assets/images/profile/dp.png"
                                                }
                                                className="rounded-circle revert-layer-img-height"
                                                width="40"
                                                height="40"
                                                alt="img"
                                              />
                                            </div>
                                            <div className="author-details">
                                              <h6>
                                                <span
                                                  style={{ cursor: "pointer" }}
                                                  onClick={() =>
                                                    handleProfileClick(
                                                      post.user?.id
                                                    )
                                                  }
                                                >
                                                  {post.user?.name}
                                                </span>
                                              </h6>

                                              <ul className="post-status">
                                                <li className="post-privacy">
                                                  <i className="icofont-world"></i>{" "}
                                                  Public
                                                </li>
                                                <li className="post-time">
                                                  {post.time_ago}
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="post-description">
                                          <p>{post.body}</p>
                                          {post.image_urls?.length > 0 && (
                                            <div className="post-desc-img">
                                              <div className="row g-3">
                                                {post.image_urls.map(
                                                  (img, idx) => (
                                                    <div
                                                      className={
                                                        post.image_urls
                                                          .length === 2
                                                          ? "col-md-6"
                                                          : "col-md-12"
                                                      }
                                                      key={idx}
                                                    >
                                                      <img
                                                        src={img}
                                                        alt="post"
                                                        className="w-100"
                                                      />
                                                    </div>
                                                  )
                                                )}
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="post-meta">
                                        <div className="post-meta-top">
                                          <p>
                                            <a href="#">
                                              <i className="icofont-like"></i>{" "}
                                              <i className="icofont-heart"></i>{" "}
                                              <span>Liked by others</span>
                                            </a>
                                          </p>
                                          <p>
                                            <a href="#">Comments</a>
                                          </p>
                                        </div>
                                        <div className="post-meta-bottom">
                                          <ul className="react-list">
                                            <li className="react">
                                              <a href="#">
                                                <i className="icofont-like"></i>{" "}
                                                Like
                                              </a>
                                            </li>
                                            <li className="react">
                                              <a href="#" onClick={(e) => openCommentModal(e, post.id)}>
                                                <i className="icofont-speech-comments"></i>{" "}
                                                Comment
                                              </a>
                                            </li>
                                            {/* <li className="react">
                                              <a href="#">
                                                <i className="icofont-share"></i>{" "}
                                                Share
                                              </a>
                                            </li> */}

                                            {post.can_edit && (
                                              <li className="react">
                                                <a
                                                  href="#"
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    setPostToDelete(post.id);
                                                  }}
                                                  className="text-danger"
                                                >
                                                  <i className="icofont-ui-delete"></i>{" "}
                                                  Delete
                                                </a>
                                              </li>
                                            )}
                                          </ul>
                                        </div>
                                      </div>

                                    </div>
                                  ))}

                                  {hasMore && (
                                    <div className="load-btn text-center my-4 py-3">
                                      <a href="#" className="dating-load-more-btn" onClick={(e) => { e.preventDefault(); getPosts(); }}>Click here for more {loadingMore && <i className="icofont-spinner dating-spinner"></i>}</a>
                                    </div>
                                  )}
                                </div>

                                <div
                                  className="tab-pane fade"
                                  id="pills-groups"
                                  role="tabpanel"
                                  aria-labelledby="pills-groups-tab"
                                >
                                  <div className="post-item mb-20">
                                    <div className="post-content">
                                      <div className="post-author">
                                        <div className="post-author-inner">
                                          <div className="author-thumb">
                                            <img
                                              src="assets/images/profile/dp.png"
                                              alt="img"
                                            />
                                          </div>
                                          <div className="author-details">
                                            <h6>
                                              <a href="#">William Smith</a>
                                            </h6>
                                            <ul className="post-status">
                                              <li className="post-privacy">
                                                <i className="icofont-world"></i>
                                                Public
                                              </li>
                                              <li className="post-time">
                                                6 Mintues Ago
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="post-description">
                                        <p>
                                          Quickly deliver going forward methods
                                          info create empowerment before
                                          client-centered bandwdth Credibly
                                          pontficate interoperable leadership
                                          skills ands B2B data awesome
                                          Continually whiteboard ands B2B data
                                          awesome Continually whiteboard
                                        </p>
                                      </div>
                                    </div>
                                    <div className="post-meta">
                                      <div className="post-meta-top">
                                        <p>
                                          <a href="#">
                                            <i className="icofont-like"></i>{" "}
                                            <i className="icofont-heart"></i>{" "}
                                            <i className="icofont-laughing"></i>
                                            <span>
                                              Julia, Petrova and 306 like this
                                            </span>
                                          </a>
                                        </p>
                                        <p>
                                          <a href="#">136 Comments</a>
                                        </p>
                                      </div>
                                      <div className="post-meta-bottom">
                                        <ul className="react-list">
                                          <li className="react">
                                            <a href="#">
                                              <i className="icofont-like"></i>
                                              Like
                                            </a>{" "}
                                          </li>
                                          <li className="react">
                                            <a href="#" onClick={(e) => { e.preventDefault(); }}>
                                              <i className="icofont-speech-comments"></i>
                                              Comment
                                            </a>
                                          </li>
                                          <li className="react">
                                            <a href="#">
                                              <i className="icofont-share"></i>{" "}
                                              Share
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>

                                  {hasMore && (
                                    <div className="load-btn text-center my-4 py-3">
                                      <a href="#" className="dating-load-more-btn" onClick={(e) => { e.preventDefault(); getPosts(); }}>Click here for more {loadingMore && <i className="icofont-spinner dating-spinner"></i>}</a>
                                    </div>
                                  )}
                                </div>

                                {!userHasPlan && posts.length >= 3 && (
                                  <div className="premium-unlock-container text-center my-4">
                                    <button
                                      className="premium-unlock-btn"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        navigate("/pricing", {
                                          state: { from: location.pathname },
                                        });
                                      }}
                                    >
                                      <div className="premium-unlock-content">
                                        <i className="icofont-star premium-icon"></i>
                                        <span className="premium-text">Show More Posts — Buy a Plan</span>
                                      </div>
                                      <div className="premium-unlock-shine"></div>
                                    </button>
                                    <style>{`
                                      .premium-unlock-container {
                                        display: flex;
                                        justify-content: center;
                                        padding: 20px 10px;
                                        width: 100%;
                                      }
                                      
                                      .premium-unlock-btn {
                                        position: relative;
                                        overflow: hidden;
                                        background: linear-gradient(45deg, #FF6B6B, #FF8E53, #FF3366, #C13584);
                                        background-size: 300% 300%;
                                        border: none;
                                        border-radius: 50px;
                                        padding: 16px 40px;
                                        color: white;
                                        font-weight: 800;
                                        font-size: 1.1rem;
                                        letter-spacing: 0.5px;
                                        cursor: pointer;
                                        box-shadow: 0 10px 20px rgba(255, 51, 102, 0.4), 0 0 15px rgba(255, 107, 107, 0.5);
                                        transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), box-shadow 0.3s ease;
                                        animation: premiumPulse 2s infinite, gradientShift 5s ease infinite;
                                        width: 100%;
                                        max-width: 450px;
                                      }
                                      
                                      .premium-unlock-btn:hover {
                                        transform: translateY(-5px) scale(1.02);
                                        box-shadow: 0 15px 25px rgba(255, 51, 102, 0.5), 0 0 25px rgba(255, 107, 107, 0.6);
                                        color: white;
                                      }
                                      
                                      .premium-unlock-btn:active {
                                        transform: translateY(2px) scale(0.98);
                                      }
                                      
                                      .premium-unlock-content {
                                        position: relative;
                                        z-index: 2;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        gap: 12px;
                                      }
                                      
                                      .premium-icon {
                                        font-size: 1.4rem;
                                        color: #FFD700;
                                        animation: starTwinkle 1.5s infinite alternate;
                                      }
                                      
                                      .premium-unlock-shine {
                                        position: absolute;
                                        top: 0;
                                        left: -100%;
                                        width: 50%;
                                        height: 100%;
                                        background: linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0.4) 50%, rgba(255,255,255,0) 100%);
                                        transform: skewX(-25deg);
                                        animation: shineSwipe 3s infinite;
                                        z-index: 1;
                                      }
                                      
                                      @keyframes premiumPulse {
                                        0% { box-shadow: 0 0 0 0 rgba(255, 51, 102, 0.6); }
                                        70% { box-shadow: 0 0 0 15px rgba(255, 51, 102, 0); }
                                        100% { box-shadow: 0 0 0 0 rgba(255, 51, 102, 0); }
                                      }
                                      
                                      @keyframes gradientShift {
                                        0% { background-position: 0% 50%; }
                                        50% { background-position: 100% 50%; }
                                        100% { background-position: 0% 50%; }
                                      }
                                      
                                      @keyframes shineSwipe {
                                        0% { left: -100%; }
                                        20% { left: 200%; }
                                        100% { left: 200%; }
                                      }
                                      
                                      @keyframes starTwinkle {
                                        0% { transform: scale(1) rotate(0deg); opacity: 0.8; filter: drop-shadow(0 0 2px rgba(255,215,0,0.5)); }
                                        100% { transform: scale(1.2) rotate(10deg); opacity: 1; filter: drop-shadow(0 0 8px rgba(255,215,0,0.9)); }
                                      }
                                      
                                      @media (max-width: 576px) {
                                        .premium-unlock-btn {
                                          padding: 14px 20px;
                                          font-size: 1rem;
                                        }
                                        .premium-icon {
                                          font-size: 1.2rem;
                                        }
                                      }
                                    `}</style>
                                  </div>
                                )}
                              </div>
                            </div>
                          </article>
                        </div>

                        <div className="col-xl-4">
                          <aside className="mt-5 mt-xl-0">
                            <FilterSearchSection />
                            {/* <WidgetLikeSection /> */}
                            <WidgetGroupSection
                              groupList={groupList}
                              loading={loadingGroups}
                            />{" "}
                          </aside>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="tab-pane fade"
                    id="profile"
                    role="tabpanel"
                    aria-labelledby="nav-profile-tab"
                  >
                    <div>
                      <div className="row">
                        <div className="col-xl-8">
                          <article>
                            <div className="info-card mb-20">
                              <div className="info-card-title">
                                <h6>Base Info</h6>
                              </div>
                              <div className="info-card-content">
                                <ul className="info-list">
                                  <li>
                                    <p className="info-name">Name</p>
                                    <p className="info-details">
                                      William Smith
                                    </p>
                                  </li>
                                  <li>
                                    <p className="info-name">I'm a</p>
                                    <p className="info-details">Woman</p>
                                  </li>
                                  <li>
                                    <p className="info-name">Loking for a</p>
                                    <p className="info-details">Men</p>
                                  </li>
                                  <li>
                                    <p className="info-name">Marital Status</p>
                                    <p className="info-details">Single</p>
                                  </li>
                                  <li>
                                    <p className="info-name">Age</p>
                                    <p className="info-details">36</p>
                                  </li>
                                  <li>
                                    <p className="info-name">Date of Birth</p>
                                    <p className="info-details">27-02-1996</p>
                                  </li>
                                  <li>
                                    <p className="info-name">Address</p>
                                    <p className="info-details">
                                      Streop Rd, Peosur, Inphodux, USA.
                                    </p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="info-card mb-20">
                              <div className="info-card-title">
                                <h6>Myself Summary</h6>
                              </div>
                              <div className="info-card-content">
                                <p>
                                  Collaboratively innovate compelling mindshare
                                  after prospective partnerships Competently
                                  sereiz long-term high-impact internal or
                                  "organic" sources via user friendly strategic
                                  themesr areas creat Dramatically coordinate
                                  premium partnerships rather than standards
                                  compliant technologies ernd Dramatically
                                  matrix ethical collaboration and idea-sharing
                                  through opensource methodologies and
                                  Intrinsicly grow collaborative platforms
                                  vis-a-vis effective scenarios. Energistically
                                  strategize cost effective ideas before the
                                  worke unde.
                                </p>
                              </div>
                            </div>
                            <div className="info-card mb-20">
                              <div className="info-card-title">
                                <h6>Looking For</h6>
                              </div>
                              <div className="info-card-content">
                                <ul className="info-list">
                                  <li>
                                    <p className="info-name">
                                      Things I'm looking for
                                    </p>
                                    <p className="info-details">
                                      I want a funny person
                                    </p>
                                  </li>
                                  <li>
                                    <p className="info-name">Whatever I like</p>
                                    <p className="info-details">
                                      I like to travel a lot
                                    </p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="info-card mb-20">
                              <div className="info-card-title">
                                <h6>Lifestyle</h6>
                              </div>
                              <div className="info-card-content">
                                <ul className="info-list">
                                  <li>
                                    <p className="info-name">Interest</p>
                                    <p className="info-details">Dogs,Cats</p>
                                  </li>
                                  <li>
                                    <p className="info-name">
                                      Favorite vocations spot
                                    </p>
                                    <p className="info-details">
                                      Maldives, Bangladesh
                                    </p>
                                  </li>
                                  <li>
                                    <p className="info-name">Looking for</p>
                                    <p className="info-details">
                                      Serious Relationshiop,Affair
                                    </p>
                                  </li>
                                  <li>
                                    <p className="info-name">Smoking</p>
                                    <p className="info-details">
                                      Casual Smoker
                                    </p>
                                  </li>
                                  <li>
                                    <p className="info-name">Language</p>
                                    <p className="info-details">
                                      English, French, Italian
                                    </p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="info-card">
                              <div className="info-card-title">
                                <h6>Physical info</h6>
                              </div>
                              <div className="info-card-content">
                                <ul className="info-list">
                                  <li>
                                    <p className="info-name">Height</p>
                                    <p className="info-details">5'8 ft</p>
                                  </li>
                                  <li>
                                    <p className="info-name">Weight</p>
                                    <p className="info-details">72 kg</p>
                                  </li>
                                  <li>
                                    <p className="info-name">Hair Color</p>
                                    <p className="info-details">Black</p>
                                  </li>
                                  <li>
                                    <p className="info-name">Eye Color</p>
                                    <p className="info-details">Brown</p>
                                  </li>
                                  <li>
                                    <p className="info-name">Body Type</p>
                                    <p className="info-details">Tall</p>
                                  </li>
                                  <li>
                                    <p className="info-name">Ethnicity</p>
                                    <p className="info-details">
                                      Middle Eastern
                                    </p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </article>
                        </div>

                        <div className="col-xl-4">
                          <aside className="mt-5 mt-xl-0">
                            <FilterSearchSection />
                            {/* <WidgetLikeSection /> */}
                            {/* <WidgetGroupSection /> */}
                          </aside>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="tab-pane fade"
                    id="friends"
                    role="tabpanel"
                    aria-labelledby="nav-friends-tab"
                  >
                    <div>
                      <div className="row">
                        <div className="col-xl-8">
                          <article>
                            <div className="row gy-4 gx-3 justify-content-center">
                              <div className=" col-lg-3 col-md-4 col-6">
                                <div className="lab-item member-item style-1">
                                  <div className="lab-inner">
                                    <div className="lab-thumb">
                                      <img
                                        src="assets/images/member/01.jpg"
                                        alt="member-img"
                                      />
                                    </div>
                                    <div className="lab-content">
                                      <h6>
                                        <Link to="/profile">jenifer Guido</Link>{" "}
                                      </h6>
                                      <p>Active 1 Day</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-3 col-md-4 col-6">
                                <div className="lab-item member-item style-1">
                                  <div className="lab-inner">
                                    <div className="lab-thumb">
                                      <img
                                        src="assets/images/member/02.jpg"
                                        alt="member-img"
                                      />
                                    </div>
                                    <div className="lab-content">
                                      <h6>
                                        <Link to="/profile">Andrea Guido</Link>{" "}
                                      </h6>
                                      <p>Active 2 Day</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-3 col-md-4 col-6">
                                <div className="lab-item member-item style-1">
                                  <div className="lab-inner">
                                    <div className="lab-thumb">
                                      <img
                                        src="assets/images/member/03.jpg"
                                        alt="member-img"
                                      />
                                    </div>
                                    <div className="lab-content">
                                      <h6>
                                        <Link to="/profile">Anna hawk</Link>{" "}
                                      </h6>
                                      <p>Active 5 Day</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-3 col-md-4 col-6">
                                <div className="lab-item member-item style-1">
                                  <div className="lab-inner">
                                    <div className="lab-thumb">
                                      <img
                                        src="assets/images/member/04.jpg"
                                        alt="member-img"
                                      />
                                    </div>
                                    <div className="lab-content">
                                      <h6>
                                        <Link to="/profile">Andreas Adam</Link>{" "}
                                      </h6>
                                      <p>Active 4 Day</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-3 col-md-4 col-6">
                                <div className="lab-item member-item style-1">
                                  <div className="lab-inner">
                                    <div className="lab-thumb">
                                      <img
                                        src="assets/images/member/05.jpg"
                                        alt="member-img"
                                      />
                                    </div>
                                    <div className="lab-content">
                                      <h6>
                                        <Link to="/profile">Alaina T</Link>{" "}
                                      </h6>
                                      <p>Active 1 Day</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-3 col-md-4 col-6">
                                <div className="lab-item member-item style-1">
                                  <div className="lab-inner">
                                    <div className="lab-thumb">
                                      <img
                                        src="assets/images/member/06.jpg"
                                        alt="member-img"
                                      />
                                    </div>
                                    <div className="lab-content">
                                      <h6>
                                        <Link to="/profile">Aron Smith</Link>{" "}
                                      </h6>
                                      <p>Active 3 Day</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-3 col-md-4 col-6">
                                <div className="lab-item member-item style-1">
                                  <div className="lab-inner">
                                    <div className="lab-thumb">
                                      <img
                                        src="assets/images/member/07.jpg"
                                        alt="member-img"
                                      />
                                    </div>
                                    <div className="lab-content">
                                      <h6>
                                        <Link to="/profile">Helen Gomz</Link>{" "}
                                      </h6>
                                      <p>Active 3 Day</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-3 col-md-4 col-6">
                                <div className="lab-item member-item style-1">
                                  <div className="lab-inner">
                                    <div className="lab-thumb">
                                      <img
                                        src="assets/images/member/08.jpg"
                                        alt="member-img"
                                      />
                                    </div>
                                    <div className="lab-content">
                                      <h6>
                                        <Link to="/profile">Andrez jr</Link>{" "}
                                      </h6>
                                      <p>Active 5 Day</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-3 col-md-4 col-6">
                                <div className="lab-item member-item style-1">
                                  <div className="lab-inner">
                                    <div className="lab-thumb">
                                      <img
                                        src="assets/images/member/09.jpg"
                                        alt="member-img"
                                      />
                                    </div>
                                    <div className="lab-content">
                                      <h6>
                                        <Link to="/profile">Ladiga Guido</Link>{" "}
                                      </h6>
                                      <p>Active 5 Day</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-3 col-md-4 col-6">
                                <div className="lab-item member-item style-1">
                                  <div className="lab-inner">
                                    <div className="lab-thumb">
                                      <img
                                        src="assets/images/member/10.jpg"
                                        alt="member-img"
                                      />
                                    </div>
                                    <div className="lab-content">
                                      <h6>
                                        <Link to="/profile">Andrea Guido</Link>{" "}
                                      </h6>
                                      <p>Active 1 Day</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-3 col-md-4 col-6">
                                <div className="lab-item member-item style-1">
                                  <div className="lab-inner">
                                    <div className="lab-thumb">
                                      <img
                                        src="assets/images/member/11.jpg"
                                        alt="member-img"
                                      />
                                    </div>
                                    <div className="lab-content">
                                      <h6>
                                        <Link to="/profile">Jene Aiko</Link>{" "}
                                      </h6>
                                      <p>Active 4 Day</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-3 col-md-4 col-6">
                                <div className="lab-item member-item style-1">
                                  <div className="lab-inner">
                                    <div className="lab-thumb">
                                      <img
                                        src="assets/images/member/12.jpg"
                                        alt="member-img"
                                      />
                                    </div>
                                    <div className="lab-content">
                                      <h6>
                                        <Link to="/profile">Jhon Cena</Link>{" "}
                                      </h6>
                                      <p>Active 2 Day</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-3 col-md-4 col-6">
                                <div className="lab-item member-item style-1">
                                  <div className="lab-inner">
                                    <div className="lab-thumb">
                                      <img
                                        src="assets/images/member/13.jpg"
                                        alt="member-img"
                                      />
                                    </div>
                                    <div className="lab-content">
                                      <h6>
                                        <Link to="/profile">Irfan Patel </Link>{" "}
                                      </h6>
                                      <p>Active 5 Day</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-3 col-md-4 col-6">
                                <div className="lab-item member-item style-1">
                                  <div className="lab-inner">
                                    <div className="lab-thumb">
                                      <img
                                        src="assets/images/member/14.jpg"
                                        alt="member-img"
                                      />
                                    </div>
                                    <div className="lab-content">
                                      <h6>
                                        <Link to="/profile">
                                          Hames Radregez
                                        </Link>{" "}
                                      </h6>
                                      <p>Active 1 Day</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-3 col-md-4 col-6">
                                <div className="lab-item member-item style-1">
                                  <div className="lab-inner">
                                    <div className="lab-thumb">
                                      <img
                                        src="assets/images/member/15.jpg"
                                        alt="member-img"
                                      />
                                    </div>
                                    <div className="lab-content">
                                      <h6>
                                        <Link to="/profile">Johan ben</Link>{" "}
                                      </h6>
                                      <p>Active 2 Day</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-3 col-md-4 col-6">
                                <div className="lab-item member-item style-1">
                                  <div className="lab-inner">
                                    <div className="lab-thumb">
                                      <img
                                        src="assets/images/member/16.jpg"
                                        alt="member-img"
                                      />
                                    </div>
                                    <div className="lab-content">
                                      <h6>
                                        <Link to="/profile">Johannes</Link>{" "}
                                      </h6>
                                      <p>Active 6 Day</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-3 col-md-4 col-6">
                                <div className="lab-item member-item style-1">
                                  <div className="lab-inner">
                                    <div className="lab-thumb">
                                      <img
                                        src="assets/images/member/17.jpg"
                                        alt="member-img"
                                      />
                                    </div>
                                    <div className="lab-content">
                                      <h6>
                                        <Link to="/profile">Helena Mind</Link>{" "}
                                      </h6>
                                      <p>Active 4 Day</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-3 col-md-4 col-6">
                                <div className="lab-item member-item style-1">
                                  <div className="lab-inner">
                                    <div className="lab-thumb">
                                      <img
                                        src="assets/images/member/18.jpg"
                                        alt="member-img"
                                      />
                                    </div>
                                    <div className="lab-content">
                                      <h6>
                                        <Link to="/profile">Virat Alba</Link>{" "}
                                      </h6>
                                      <p>Active 3 Day</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-3 col-md-4 col-6">
                                <div className="lab-item member-item style-1">
                                  <div className="lab-inner">
                                    <div className="lab-thumb">
                                      <img
                                        src="assets/images/member/19.jpg"
                                        alt="member-img"
                                      />
                                    </div>
                                    <div className="lab-content">
                                      <h6>
                                        <Link to="/profile">Afrin Nawr</Link>{" "}
                                      </h6>
                                      <p>Active 5 Day</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-3 col-md-4 col-6">
                                <div className="lab-item member-item style-1">
                                  <div className="lab-inner">
                                    <div className="lab-thumb">
                                      <img
                                        src="assets/images/member/20.jpg"
                                        alt="member-img"
                                      />
                                    </div>
                                    <div className="lab-content">
                                      <h6>
                                        <Link to="/profile">Jason Roy</Link>{" "}
                                      </h6>
                                      <p>Active 2 Day</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </article>
                        </div>

                        <div className="col-xl-4">
                          <aside className="mt-5 mt-xl-0">
                            <FilterSearchSection />
                            {/* <WidgetLikeSection /> */}
                            {/* <WidgetGroupSection /> */}
                          </aside>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="tab-pane fade"
                    id="groups"
                    role="tabpanel"
                    aria-labelledby="nav-groups-tab"
                  >
                    <div>
                      <div className="row">
                        <div className="col-xl-8">
                          <article>
                            <div className="row gy-3">
                              <GroupItemTwo itemNumber={4} />
                            </div>
                          </article>
                        </div>

                        <div className="col-xl-4">
                          <aside className="mt-5 mt-xl-0">
                            <FilterSearchSection />
                            {/* <WidgetLikeSection /> */}
                            {/* <WidgetGroupSection /> */}
                          </aside>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="photos"
                    role="tabpanel"
                    aria-labelledby="nav-photos-tab"
                  >
                    <AllPhotos />
                  </div>
                  <div
                    className="tab-pane fade"
                    id="media"
                    role="tabpanel"
                    aria-labelledby="nav-media-tab"
                  >
                    <div>
                      <div className="row">
                        <div className="col-xl-8">
                          <article>
                            <div className="media-wrapper">
                              <ul
                                className="nav nav-tabs"
                                id="myTab"
                                role="tablist"
                              >
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link active"
                                    id="all-media-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#all-media"
                                    type="button"
                                    role="tab"
                                    aria-controls="all-media"
                                    aria-selected="true"
                                  >
                                    <i className="icofont-star"></i> All Media
                                  </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link"
                                    id="album-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#album"
                                    type="button"
                                    role="tab"
                                    aria-controls="album"
                                    aria-selected="false"
                                  >
                                    <i className="icofont-layout"></i> Albums
                                    <span>04</span>
                                  </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link"
                                    id="photos-media-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#photos-media"
                                    type="button"
                                    role="tab"
                                    aria-controls="photos-media"
                                    aria-selected="false"
                                  >
                                    <i className="icofont-image"></i>
                                    Photos <span>12</span>
                                  </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link"
                                    id="video-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#video"
                                    type="button"
                                    role="tab"
                                    aria-controls="video"
                                    aria-selected="false"
                                  >
                                    <i className="icofont-video-alt"></i> Videos
                                    <span>0</span>
                                  </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link"
                                    id="music-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#music"
                                    type="button"
                                    role="tab"
                                    aria-controls="music"
                                    aria-selected="false"
                                  >
                                    <i className="icofont-music-disk"></i> Music
                                    <span>0</span>
                                  </button>
                                </li>
                              </ul>
                              <div className="tab-content" id="myTabContent">
                                <div
                                  className="tab-pane fade show active"
                                  id="all-media"
                                  role="tabpanel"
                                  aria-labelledby="all-media-tab"
                                >
                                  <div className="media-title">
                                    <h3>Media Gallery</h3>
                                  </div>
                                  <div className="media-content">
                                    <ul className="media-upload">
                                      <li className="upload-now">
                                        <div className="custom-upload">
                                          <div className="file-btn">
                                            <i className="icofont-upload-alt"></i>
                                            Upload
                                          </div>
                                          <input type="file" />
                                        </div>
                                      </li>
                                    </ul>
                                    <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-5 row-cols-xl-4 g-3">
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/01.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/02.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/03.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/04.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/05.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/06.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/07.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/08.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/09.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/10.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/11.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/12.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/03.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/02.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    {hasMore && (
                                    <div className="load-btn text-center my-4 py-3">
                                      <a href="#" className="dating-load-more-btn" onClick={(e) => { e.preventDefault(); getPosts(); }}>Click here for more {loadingMore && <i className="icofont-spinner dating-spinner"></i>}</a>
                                    </div>
                                  )}
                                  </div>
                                </div>

                                <div
                                  className="tab-pane fade"
                                  id="album"
                                  role="tabpanel"
                                  aria-labelledby="album-tab"
                                >
                                  <div className="media-title">
                                    <h3>Album Lists</h3>
                                  </div>
                                  <div className="media-content">
                                    <ul className="media-upload">
                                      <li className="upload-now">
                                        <div className="custom-upload">
                                          <div className="file-btn">
                                            <i className="icofont-upload-alt"></i>
                                            Upload
                                          </div>
                                          <input type="file" />
                                        </div>
                                      </li>
                                    </ul>
                                    <div className="row g-4">
                                      <div className="col-lg-4 col-sm-6">
                                        <div className="album text-center">
                                          <div className="album-thumb">
                                            <a href="#">
                                              <img
                                                src="assets/images/member/02.jpg"
                                                alt="album"
                                              />
                                            </a>
                                          </div>
                                          <div className="album-content">
                                            <h6>Private</h6>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-4 col-sm-6">
                                        <div className="album text-center">
                                          <div className="album-thumb">
                                            <a href="#">
                                              <img
                                                src="assets/images/member/03.jpg"
                                                alt="album"
                                              />
                                            </a>
                                          </div>
                                          <div className="album-content">
                                            <h6>Crush</h6>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-4 col-sm-6">
                                        <div className="album text-center">
                                          <div className="album-thumb">
                                            <a href="#">
                                              <img
                                                src="assets/images/member/06.jpg"
                                                alt="album"
                                              />
                                            </a>
                                          </div>
                                          <div className="album-content">
                                            <h6>Public</h6>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-4 col-sm-6">
                                        <div className="album text-center">
                                          <div className="album-thumb">
                                            <a href="#">
                                              <img
                                                src="assets/images/member/08.jpg"
                                                alt="album"
                                              />
                                            </a>
                                          </div>
                                          <div className="album-content">
                                            <h6>Favorite</h6>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {hasMore && (
                                    <div className="load-btn text-center my-4 py-3">
                                      <a href="#" className="dating-load-more-btn" onClick={(e) => { e.preventDefault(); getPosts(); }}>Click here for more {loadingMore && <i className="icofont-spinner dating-spinner"></i>}</a>
                                    </div>
                                  )}
                                  </div>
                                </div>
                                <div
                                  className="tab-pane fade"
                                  id="photos-media"
                                  role="tabpanel"
                                  aria-labelledby="photos-media-tab"
                                >
                                  <div className="media-title">
                                    <h2>All Photos</h2>
                                  </div>
                                  <div className="media-content">
                                    <ul className="media-upload">
                                      <li className="upload-now">
                                        <div className="custom-upload">
                                          <div className="file-btn">
                                            <i className="icofont-upload-alt"></i>
                                            Upload
                                          </div>
                                          <input type="file" />
                                        </div>
                                      </li>
                                    </ul>
                                    <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-5 row-cols-xl-4 g-3">
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/01.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/02.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/03.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/04.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/05.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/06.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/07.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/08.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/09.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/10.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/11.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/12.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/03.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/02.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    {hasMore && (
                                    <div className="load-btn text-center my-4 py-3">
                                      <a href="#" className="dating-load-more-btn" onClick={(e) => { e.preventDefault(); getPosts(); }}>Click here for more {loadingMore && <i className="icofont-spinner dating-spinner"></i>}</a>
                                    </div>
                                  )}
                                  </div>
                                </div>

                                <div
                                  className="tab-pane fade"
                                  id="video"
                                  role="tabpanel"
                                  aria-labelledby="video-tab"
                                >
                                  <div className="media-title">
                                    <h3>All Videos</h3>
                                  </div>
                                  <div className="media-content">
                                    <ul className="media-upload">
                                      <li className="upload-now">
                                        <div className="custom-upload">
                                          <div className="file-btn">
                                            <i className="icofont-upload-alt"></i>
                                            Upload
                                          </div>
                                          <input type="file" />
                                        </div>
                                      </li>
                                    </ul>
                                    <div className="row">
                                      <div className="col">
                                        <p>
                                          <i className="icofont-worried"></i>{" "}
                                          Sorry !! There's no media found for
                                          the request !!{" "}
                                        </p>
                                      </div>
                                    </div>
                                    {hasMore && (
                                    <div className="load-btn text-center my-4 py-3">
                                      <a href="#" className="dating-load-more-btn" onClick={(e) => { e.preventDefault(); getPosts(); }}>Click here for more {loadingMore && <i className="icofont-spinner dating-spinner"></i>}</a>
                                    </div>
                                  )}
                                  </div>
                                </div>

                                <div
                                  className="tab-pane fade"
                                  id="music"
                                  role="tabpanel"
                                  aria-labelledby="music-tab"
                                >
                                  <div className="media-title">
                                    <h3>All Music</h3>
                                  </div>
                                  <div className="media-content">
                                    <ul className="media-upload">
                                      <li className="upload-now">
                                        <div className="custom-upload">
                                          <div className="file-btn">
                                            <i className="icofont-upload-alt"></i>
                                            Upload
                                          </div>
                                          <input type="file" />
                                        </div>
                                      </li>
                                    </ul>
                                    <div className="row">
                                      <div className="col">
                                        <p>
                                          <i className="icofont-worried"></i>{" "}
                                          Sorry !! There's no media found for
                                          the request !!{" "}
                                        </p>
                                      </div>
                                    </div>
                                    {hasMore && (
                                    <div className="load-btn text-center my-4 py-3">
                                      <a href="#" className="dating-load-more-btn" onClick={(e) => { e.preventDefault(); getPosts(); }}>Click here for more {loadingMore && <i className="icofont-spinner dating-spinner"></i>}</a>
                                    </div>
                                  )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </article>
                        </div>

                        <div className="col-xl-4">
                          <aside className="mt-5 mt-xl-0">
                            <FilterSearchSection />
                            {/* <WidgetLikeSection /> */}
                            {/* <WidgetGroupSection /> */}
                          </aside>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FooterSection />
      
      <CommentModal
        show={showCommentModal}
        onHide={() => setShowCommentModal(false)}
        postId={activeCommentPostId}
      />
    </div>
  );
};
export default PostPage;
